import { render, staticRenderFns } from "./BookingsList.vue?vue&type=template&id=bb08772a&scoped=true"
import script from "./BookingsList.vue?vue&type=script&lang=js"
export * from "./BookingsList.vue?vue&type=script&lang=js"
import style0 from "./BookingsList.vue?vue&type=style&index=0&id=bb08772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb08772a",
  null
  
)

export default component.exports